import { useQuery } from '@tanstack/react-query';
import { useCampaignShop } from '@/components/features/campaigns';
import { useUnclaimedGamificationRewardsCount } from '@/components/features/gamification/modules/rewards/hooks/useUnclaimedGamificationRewardsCount';
import { SHOP_BADGE_KEY } from '@/components/features/layout/Navigation/consts/links';
import { useIsReferralUnlocked } from '@/components/features/referral/hooks/useIsReferralUnlocked';
import { getReferralSidebarMarker } from '@/components/features/referral/model/utils/getReferralSidebarMarker';
import { AppRoutes } from '@/i18n/constants';
import { referralQueryOptions } from '@/queries/referral/referral.queries';
import { useAppSelector } from '@/redux/hooks';

/** Badges by `getNavigationBadgeKey`, overriding a link's static badge. */
export const useNavigationBadges = (): Partial<Record<string, string | number>> => {
  const userSession = useAppSelector(state => state.user.userSession);
  const isReferralUnlocked = useIsReferralUnlocked();

  const { data: refereesCount } = useQuery(
    referralQueryOptions.meRefereesCount({ enabled: isReferralUnlocked }),
  );
  const { sidebarCountRewards } = useUnclaimedGamificationRewardsCount();
  const { promoBadge } = useCampaignShop();

  return {
    [AppRoutes.referral]: getReferralSidebarMarker(!!userSession, refereesCount?.unviewed),
    [AppRoutes.gamificationRewards]: sidebarCountRewards,
    [SHOP_BADGE_KEY]: promoBadge ?? undefined,
  };
};
